import {
    GET_USER_NOTIFICATION_PERMISSION_SUCCESS,
    GET_USER_NOTIFICATION_PERMISSION_FAILURE
} from "./actions";

const initialState = {
    permission: null,
    error: null,
};

const notificationPermissionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_NOTIFICATION_PERMISSION_SUCCESS:
            return {
                ...state,
                permission: action.payload,
                error: null,
            };
        case GET_USER_NOTIFICATION_PERMISSION_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default notificationPermissionReducer;
